/**
 * 版本配置文件
 */

export const VERSION_INFO = {
  version: '1.5.8',
  buildNumber: 158,
  releaseDate: '2025-09-05',
  features: [
    'Game-style visual novel interface',
    'Princess character system',
    'Message stacking with fade animations',
    'Intelligent exercise generation',
    'Translation practice improvements',
    'PNG asset support', 
    'Interface style selection in settings',
    'Dynamic UI switching (Game/Traditional)',
    'Enhanced user experience',
    'Supabase session persistence',
    'Unified JWT authentication system',
    'Domain name security truncation',
    'Fixed translation practice user message filtering',
    'AI-powered reference translation generation',
    'Resolved infinite loop in practice readiness',
    'React Native for Web support',
    'Web SPA version with full feature parity',
    'Webpack-based build system',
    'PWA capabilities with service worker',
    'Multi-platform development environment',
    'Complete backend-driven vocabulary system',
    'Completely removed all frontend vocabulary processing',
    'No local vocabulary caching or analysis on client',
    'Pure backend-only vocabulary API architecture', 
    'Client focuses solely on UI/UX, no service logic',
    'All vocabulary analysis moved to backend API',
    'Completely removed legacy vocabularyService.ts file',
    'Fixed duplicate vocabulary processing issue',
    'Implemented memory curve-based practice system',
    'Added Ebbinghaus forgetting curve for spaced repetition',
    'Enhanced phonetic display system with improved extraction',
    'Database security improvements with RLS policies',
  ],
  compatibleApiVersion: '1.3.1',
} as const;

// 构建环境配置 - 独立控制各种功能
export const APP_CONFIG = {
  // 后端服务器选择: 'development' | 'production'
  BACKEND_TARGET: 'production' as 'development' | 'production',

  // 后台健康检查服务: true | false
  ENABLE_HEALTH_CHECK: false,

  // 调试日志: true | false
  ENABLE_DEBUG_LOGS: true,

  // 界面风格选择: 'game' | 'traditional'
  // 'game' = 游戏风格视觉小说界面 (新版)
  // 'traditional' = 传统聊天界面 (已验证版本)
  CHAT_INTERFACE_STYLE: 'game' as 'game' | 'traditional',
} as const;

// 环境标识（保留原有逻辑以兼容现有代码）
export const BUILD_INFO = {
  isDevelopment: __DEV__,
  isProduction: !__DEV__,
  environment: __DEV__ ? 'DEV' : 'PROD',
  buildType: __DEV__ ? 'Debug' : 'Release',
} as const;

// 版本显示格式
export const getVersionString = (): string => {
  const env = BUILD_INFO.environment;
  return `v${VERSION_INFO.version}${env === 'DEV' ? '-dev' : ''}`;
};

// 完整版本信息
export const getFullVersionInfo = () => ({
  ...VERSION_INFO,
  ...BUILD_INFO,
  displayVersion: getVersionString(),
});
